import { render, staticRenderFns } from "./validation_classification.vue?vue&type=template&id=58f24e2a"
import script from "./validation_classification.vue?vue&type=script&lang=js"
export * from "./validation_classification.vue?vue&type=script&lang=js"
import style0 from "./validation_classification.vue?vue&type=style&index=0&id=58f24e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports